/**
 * Theme base JavaScript.
 * Handles: timezone clock, mobile menu toggle, announcement bar.
 * No jQuery. No Udesly.
 */
(function () {
  'use strict';

  /* -----------------------------------------------
   * Timezone Clock
   * Updates .date and .time elements every minute.
   * Timezone is set in theme settings.
   * ----------------------------------------------- */

  function initClock() {
    var timezone = window.theme && window.theme.timezone;
    if (!timezone) {
      // Fallback: read from inline config set in layout
      var configEl = document.querySelector('[data-timezone]');
      if (configEl) timezone = configEl.getAttribute('data-timezone');
    }
    if (!timezone) return;

    function updateClock() {
      var now = new Date();
      var dateStr = now.toLocaleDateString('en-US', { timeZone: timezone });
      var timeStr = now.toLocaleTimeString('en-US', {
        timeZone: timezone,
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZoneName: 'short'
      });

      var dateEls = document.getElementsByClassName('date');
      for (var i = 0; i < dateEls.length; i++) {
        dateEls[i].textContent = dateStr;
      }

      var timeEls = document.getElementsByClassName('time');
      for (var j = 0; j < timeEls.length; j++) {
        timeEls[j].textContent = timeStr;
      }
    }

    updateClock();
    setInterval(updateClock, 60000);
    debug.trace('clock:init', { timezone: timezone });
  }

  /* -----------------------------------------------
   * Mobile Menu Toggle
   * ----------------------------------------------- */

  function initMobileMenu() {
    var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggleBtn || !menu) return;

    toggleBtn.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      debug.trace('mobileMenu:toggle', { open: isOpen });
    });

    // Close on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.focus();
      }
    });
  }

  /* -----------------------------------------------
   * Announcement Bar - Scrolling Text
   * ----------------------------------------------- */

  function initAnnouncementBar() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    // Scrolling text is handled via CSS animation (see theme.css).
    // JS handles the float/dismiss behavior if needed.
    debug.trace('announcement:init');
  }

  /* -----------------------------------------------
   * Init
   * ----------------------------------------------- */

  function init() {
    initClock();
    initMobileMenu();
    initAnnouncementBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
